import { getNegotiationStatuses, postNegotiationStatus, putNegotiationStatus } from '../../../Api/services/backoffice';

export const key = 'negotiationStatus';

const entityName = {
  singular: 'Status da Negociação',
  plural: 'Status da Negociaçãos',
};

const queries = {
  list: { key, fn: getNegotiationStatuses },
  detail: { key },
};

const mutations = {
  create: postNegotiationStatus,
  update: putNegotiationStatus,
};

const fields = {
  table: [{ key: 'name', label: 'Nome' }],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
